<div class="grid-container">
  <div class="grid-x">
    <div class="cell large-6 medium-6 small-6 text-align-right">
      <span [ngStyle]="{ 'display': (result != null && result.records.length > 0) ? 'inherit': 'none' }">
        <pagination [currentPage]="currentPage" [totalResults]="result?.totalRecords" (pageChanged)="onPageChanged($event)"></pagination>
      </span>
    </div>
    <div class="cell large-6 medium-6 small-6 text-align-left padding-left">
      <span [ngStyle]="{ 'display': (result != null && result.records.length > 0) ? 'inherit': 'none' }">
        <button class="button" (click)="confirmAll()">
          Download All&nbsp;&nbsp;<svg-icon icon="icon-download" class="white">Download All</svg-icon>
        </button>
      </span>
    </div>
  </div>
  @if (result?.totalRecords > 0) {
    @if (result?.totalRecords > query.maxResults) {
      <div>Your OnBase document search returned more than the {{query.maxResults}} maximum documents.
      Please use documents group, document type and keyword selections to refine your search.</div>
    }
    <div class="grid-x border-right border-left border-top">
      <div class="cell large-5 medium-5 small-5 bold padding-all-small" style="line-height: 2rem; vertical-align: middle;">
        <column-header [property]="'Document Name'" (sorting)="onSorting($event)"></column-header>
      </div>
      <div class="cell large-3 medium-3 small-3 bold border-left padding-all-small" style="line-height: 2rem; vertical-align: middle;">
        <column-header [property]="'Document Type'" (sorting)="onSorting($event)"></column-header>
      </div>
      <div class="cell large-4 medium-4 small-4 bold  border-left padding-all-small" style="line-height: 2rem; vertical-align: middle;">
        <column-header [property]="'Keywords'" [allowSorting]="false"></column-header>
      </div>
    </div>
    <div class="grid-x grid-section margin-bottom-large border-right border-left border-top border-bottom">
      @for (doc of result.records; track doc; let i = $index) {
        <div class="cell large-5 medium-5 small-5 result-size padding-all-small" [ngClass]="{ 'striping': i % 2 === 0, 'border-bottom': i != result.records.length -1 }">
          <button (click)="download(doc.documentId)">
            <svg-icon icon="icon-download" class="black"></svg-icon>
          </button>
          {{ doc.name }} @if (parseFileNameFromKeywords(doc) !== doc.name) {
          <span class="italic">(Original File Name: {{parseFileNameFromKeywords(doc)}})</span>
        }
      </div>
      <div class="cell large-3 medium-3 small-3 result-size border-left padding-all-small" [ngClass]="{ 'striping': i % 2 === 0, 'border-bottom': i != result.records.length -1  }">
        {{ translateDocumentType(doc) }}
      </div>
      <div class="cell large-4 medium-4 small-4 result-size border-left padding-all-small" [ngClass]="{ 'striping': i % 2 === 0, 'border-bottom': i != result.records.length -1 }">
        <ul>
          @for (pair of filteredKeywords(doc); track pair) {
            <li><span [ngClass]="{ 'bold' : keywordQueried(pair) }">{{pair.key}} : {{pair.value}}</span></li>
          }
        </ul>
      </div>
    }
  </div>
} @else {
  @if (result != null) {
    <div class="grid-x grid-margin-x">
      <div class="cell large-12 medium-12 small-12 bold red">
        There are no results for your search.
      </div>
    </div>
  }
}
</div>
<a style="display: none;" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>

